import { createContext } from 'react';
const initialProductVariationContextState = {
    quantity: 1,
    selectedVariation: null,
    selectedOptions: {},
    options: [],
    product: null,
    getSelectableOptionItems: null,
    setMissingOption: null,
    hasMissingOption: false,
    missingOption: null,
    missingOptions: []
};
const ProductVariationContext = createContext(initialProductVariationContextState);
export default ProductVariationContext;
export const ProductVariationConsumer = ProductVariationContext.Consumer;
//# sourceMappingURL=ProductVariationContext.js.map